import errorReporter from '@app/errorReporter';

angular.module('bb.assets').component('bbFolderModal', {
  controller: FolderModalController,
  controllerAs: 'vm',
  template: require('./folder_modal.html'),
});

FolderModalController.$inject = ['ModalService', 'AssetsService', '$scope'];

function FolderModalController(ModalService, AssetsService, $scope) {
  const vm = this;

  vm.folderModal = ModalService.folderModal;

  vm.toggleAdminOnly = () => {
    vm.folderModal.folder.adminOnly = !vm.folderModal.folder.adminOnly;
    $scope.$digest();
  };

  vm.closeModal = () => {
    ModalService.closeFolderModal();
  };

  vm.saveFolder = () => {
    if (!vm.folderModal.folder.name) {
      vm.showError = true;
      return;
    }
    vm.saving = true;
    AssetsService.saveFolder(vm.folderModal.folder)
      .then(() => {
        ModalService.closeFolderModal(true);
      })
      .catch(errorReporter.error)
      .finally(() => {
        vm.saving = false;
      });
  };

  vm.deleteFolder = () => {
    swal(
      {
        title: 'Delete Folder',
        text: 'Are you sure you want to permanently delete this folder and all of its contents?',
        html: true,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#62cb31',
        confirmButtonText: 'Delete',
        closeButtonText: 'Cancel',
        closeOnConfirm: true,
      },
      () => {
        AssetsService.deleteFolder(vm.folderModal.folder.id).then(() => {
          ModalService.closeFolderModal(true);
        });
      },
    );
  };
}
